import Phaser from 'phaser';

interface PreyLike {
  x: number;
  y: number;
  active: boolean;
}

/**
 * Pulsing ring drawn around a prey entity while it is being consumed.
 * Shrinks as consume progress advances so the player sees the meal
 * actually being worked on. Swapped out for a proper tentacle shader
 * when visual polish lands.
 */
export class ConsumePulse {
  private ring: Phaser.GameObjects.Arc;
  private tether: Phaser.GameObjects.Line;
  private tween: Phaser.Tweens.Tween | null = null;

  constructor(
    private readonly scene: Phaser.Scene,
    private readonly blob: PreyLike,
    private readonly prey: PreyLike,
    baseRadius: number,
  ) {
    const r = Math.max(14, baseRadius + 8);
    this.ring = scene.add
      .circle(prey.x, prey.y, r, 0x9cff9c, 0)
      .setStrokeStyle(2, 0x9cff9c, 0.75)
      .setDepth(400);
    this.tether = scene.add
      .line(0, 0, blob.x, blob.y, prey.x, prey.y, 0x9cff9c, 0.55)
      .setLineWidth(1.5)
      .setOrigin(0)
      .setDepth(399);
    this.tween = scene.tweens.add({
      targets: this.ring,
      scale: { from: 1, to: 0.55 },
      alpha: { from: 0.95, to: 0.45 },
      duration: 520,
      yoyo: true,
      repeat: -1,
    });
  }

  follow(): void {
    if (!this.prey.active) {
      this.destroy();
      return;
    }
    this.ring.setPosition(this.prey.x, this.prey.y);
    this.tether.setTo(this.blob.x, this.blob.y, this.prey.x, this.prey.y);
  }

  setProgress(t: number): void {
    // Tether alpha grows with progress so the "drain" feels stronger late
    this.tether.setAlpha(0.4 + 0.4 * Math.min(1, t));
  }

  destroy(): void {
    this.tween?.stop();
    this.tween = null;
    this.ring.destroy();
    this.tether.destroy();
  }
}
